import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "bootstrap/dist/css/bootstrap.css";
import Dropdown from "react-bootstrap/Dropdown";
import "./Navbar.css";
import { NavLink } from "react-router-dom";
import { fetchUserData } from "../../Providers/CatalogDataService";
import { fetchUserBadges } from "../../Providers/CatalogDataService";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  loadCoursesToShow,
  fetchCourses,
} from "../../Providers/CourseDataProvider";

function NavbarData() {
  const [userData, setUserData] = useState([]);
  const [badges, setBadges] = useState([]);

  const [activeLink, setActiveLink] = useState("");
  const location = useLocation();

  const [availableCourses, setAvailableCourses] = useState([]);

  useEffect(() => {
    fetchUserData().then((res) => setUserData(res));
  }, []);

  useEffect(() => {
    fetchUserBadges().then((res) => setBadges(res));
  }, []);

  const handleNavLinkClick = (link) => {
    setActiveLink(link);
  };

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    fetchUserData().then((res) => setUserData(res));
    fetchUserBadges().then((res) => setBadges(res));
    loadCoursesToShow().then((res) => setAvailableCourses(res));
  }, []);

  useEffect(() => {
    fetchCourses(availableCourses, "eager").then((response) =>
      console.log(`Total courses prefetched: ${response.length}`),
    );
  }, [availableCourses]);

  return (
    <div className="nav-bar">
      <Navbar expand="md" className="navbar-res">
        <Container fluid style={{ width: "100rem", marginLeft: "4%" }}>
          <Navbar.Brand href="index.html">
            <img
              className="launch-logo"
              src="./HomePageImages/launch_logo.png"
              alt="launch_logo"
            ></img>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto d-flex gap-3">
              <Nav.Link href="index.html">
                <img
                  className="home_icon"
                  src="./HomePageImages/homeicon.png"
                  alt="home_icon"
                ></img>
              </Nav.Link>

              <NavLink
                to="/belaunchified"
                className={`launchified_data ${activeLink === "/belaunchified" ? "active" : ""}`}
                onClick={() => handleNavLinkClick("/belaunchified")}
              >
                Be Launchified
              </NavLink>

              <NavLink
                className={`launchified_data ${activeLink === "/resources" ? "active" : ""}`}
                to="/resources"
                onClick={() => handleNavLinkClick("/resources")}
              >
                Resources
              </NavLink>
            </Nav>

            <Nav className="ms-auto d-flex gap-4 leftnav">
              <Dropdown>
                <Dropdown.Toggle id="dropdown-basic" className="dropd">
                  Hi, {userData[0]}{" "}
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-card">
                  <div className="dropdown-header-black">
                    <div className="profile-pic-container">
                      <img
                        src={userData[1]}
                        alt="profile"
                        className="profile-pic-header"
                      />
                    </div>
                    <img
                      src="./HomePageImages/MainiconLaunch.png"
                      alt="Logo"
                      className="header-logo"
                    />
                  </div>
                  <div className="user-info-section">
                    <div className="user-name">{userData[0]} </div>
                    <div className="horizontal-vector"></div>
                  </div>
                  <div className="dropdown-content">
                    <div className="badges-section">
                      <div className="menu-options">
                        <Dropdown.Item href="#/badge" className="menu-course">
                          <img
                            className="drop_icon"
                            src="./HomePageImages/drop_shield.png"
                            alt="badge_icon"
                          />
                          <span className="spacef">Badges</span>
                        </Dropdown.Item>
                      </div>
                    </div>
                    <div className="horizontal-vector"></div>

                    <div className="menu-options">
                      <Dropdown.Item
                        href="#/certifications"
                        className="menu-course"
                      >
                        <img
                          className="drop_icon"
                          src="./HomePageImages/drop_courses.png"
                          alt="courses_icon"
                        />
                        <span className="spacef">Completed Courses</span>
                      </Dropdown.Item>
                      <div className="horizontal-vector"></div>
                      <Dropdown.Item
                        className="menu-course"
                        href="https://catalys.portal.nttdataservices.com/"
                      >
                        <img
                          className="drop_icon"
                          src="./HomePageImages/drop_logout.png"
                          alt="logout_icon"
                        />
                        <span className="spacef">Go to Catalys</span>
                      </Dropdown.Item>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>

              <Nav.Link className="d-flex align-items-center">
                <br />
                <img
                  className="nttdata_icon"
                  src="./HomePageImages/nttdata.png"
                  alt="nttdata_icon"
                />
                <div className="Vector-2"></div>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
          <div className="vector_h"></div>
        </Container>
      </Navbar>
    </div>
  );
}
export default NavbarData;
